<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 15:53:39
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 16:10:16
 -->
<template>
  <div class="productCharacteristic">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">产品特点</span>
    </div>
    <div class="content">
      <div class="left">
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">集成车牌识别、车型识别、图像处理于一体，多角度监控，智能补光一体化设计</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">深度学习算法，结合大数据模型，算法成熟，识别率高</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">符合《高速公路称重检测业务规范和技术要求》，完全满足高速公路入口治超的“三张图”抓拍和不少于5S视频保存的需要</span></div>
      </div>
      <div class="right">
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">符合《收费公路车辆通行费车型分类（JT489-2019）》车辆分类新标准</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">单侧安装在收费岛上，不破坏收费岛结构</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">系统方便升级、可适应未来出现的新车型，无需改动硬件设备</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productCharacteristic',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .productCharacteristic {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 40px;
      font-size: 20px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .content {
      width: 100%;
      >div {
        width: 50%;
        height: 100%;
        display: inline-block;
      }
      .item {
        font-size: 17px;
        color: #05dbe3;
        display: flex;
        justify-content: space-between;
        .el-icon-circle-check {
          font-size: 24px;
          font-weight: bold;
          margin-right: 10px;
          display: inline-block;
          width: 3%;
          line-height: 40px;
        }
        .text {
          display: inline-block;
          width: 96%;
          line-height: 40px;
          color: rgb(10, 178, 167);
        }
      }
    }
  }
</style>
